<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
<!--            <div class="btn-group">-->
<!--                <v-flex class="btn-block">-->
<!--                    <div class="d-inline-flex" v-if="deviceData.state != null">-->
<!--                        <v-switch-->
<!--                            v-model="deviceState"-->
<!--                            inset-->
<!--                            dense-->
<!--                            hide-details-->
<!--                            class="pa-0"-->
<!--                            @click="changeDeviceSwitch"-->
<!--                            :loading="loading"-->
<!--                            :disabled="deviceData.disabled"-->
<!--                            color="#FF8484"-->
<!--                            v-if="free"-->
<!--                        ></v-switch>-->
<!--                        <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid" v-else :not-free="!free"></device-switch-disabled>-->
<!--                    </div>-->
<!--                </v-flex>-->
<!--            </div>-->
        </v-layout>
        <v-layout row class="small-text ma-0 mt-3">
            Текущее состояние: <span class="small-text font-weight-medium mx-1">{{textValue}}</span>
        </v-layout>
        <div class="small-text ma-0 mt-3 btn-row" v-if="deviceData.state">
            <v-btn
                class="btn-light-grey small-btn mr-2"
                @click="sendDeviceValue('opening')"
                :disabled="deviceData.state.running || loading || deviceData.state.value == 100"
            >
                <v-img max-height="24px" max-width="24px" :src="require('@/assets/icons/arrow_down_icon.svg')" class="rotate-90"/>
                <v-img max-height="24px" max-width="24px" :src="require('@/assets/icons/arrow_down_icon.svg')" class="rotate-270"/>
            </v-btn>
            <v-btn
                :loading="loading"
                class="btn-light-grey small-btn mx-2"
                @click="sendDeviceValue('stop')"
                :disabled="!deviceData.state.running || loading"
            >
                <v-img max-height="24px" max-width="24px" :src="require('@/assets/icons/pause.svg')" class="d-inline-flex"/>
            </v-btn>
            <v-btn
                class="btn-light-grey small-btn mr-2"
                @click="sendDeviceValue('closing')"
                :disabled="deviceData.state.running || loading || deviceData.state.value == 0"
            >
                <v-img max-height="24px" max-width="24px" :src="require('@/assets/icons/arrow_down_icon.svg')" class="rotate-270"/>
                <v-img max-height="24px" max-width="24px" :src="require('@/assets/icons/arrow_down_icon.svg')" class="rotate-90"/>
            </v-btn>
        </div>
<!--        <div class="vue-slider-row mt-3" v-if="deviceData.state">-->
<!--            <div class="vue-slider-prepend">-->
<!--                <span class="main-text">0%</span>-->
<!--            </div>-->
<!--            <div class="vue-custom-slider-container">-->
<!--                <vue-slider-->
<!--                    v-model="deviceData.state.value"-->
<!--                    :adsorb="true"-->
<!--                    :interval="1"-->
<!--                    :min="0"-->
<!--                    :max="100"-->
<!--                    :height="16"-->
<!--                    :lazy="true"-->
<!--                    :disabled="loading || !free || deviceData.disabled"-->
<!--                    tooltip-formatter="{value}%"-->
<!--                    tooltip="always"-->
<!--                    class="vue-custom-slider"-->
<!--                    @change="changeDeviceSlider"-->
<!--                />-->
<!--            </div>-->
<!--            <div class="vue-slider-append">-->
<!--                <span class="main-text">100%</span>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";

export default {
    name: "CurtainsDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            valueSlider: 50,
            deviceStateOldValue: null,
            deviceState: false,
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state ? this.deviceData.state.value > 0 ? true : false : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    computed: {
        textValue() {
            return this.deviceData.state ?
                this.deviceData.state.value == null ? "открыты" :
                    this.deviceData.state.value == 0 ? "закрыты" :
                        this.deviceData.state.value == 100 ? "открыты" :
                            this.deviceData.state.value > 49 ? `открыты на ${this.deviceData.state.value}%` :
                                `закрыты на ${100 - this.deviceData.state.value}%` :
                                    "не определено";
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state ? this.deviceData.state.value > 0 ? true : false : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        changeDeviceSwitch() {
            if (this.deviceState) {
                this.deviceData.state.value = 100;
            } else {
                this.deviceData.state.value = 0;
            }
            this.changeDeviceValue();
        },
        changeDeviceSlider() {
            setTimeout(() => {
                this.changeDeviceValue();
            }, 1000);
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    this.loading = false;
                    console.log(error);
                });
        },
        sendDeviceValue(state) {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                command: state,
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.loading = false;
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-row {
    gap: 16px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.small-btn.btn-light-grey.v-btn {
    min-width: 64px;
    max-width: 30%;
    display: inline-flex;
}
.rotate-90.v-image {
    transform: rotate(90deg);
}
.rotate-270.v-image {
    transform: rotate(270deg);
}
</style>